var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"size":_vm.size || 'default',"options":_vm.channelCascadeOptions,"props":_vm.props,"show-all-levels":false,"clearable":"","collapse-tags":"","filterable":""},on:{"change":_vm.handleChange},model:{value:(_vm.channelCascadeIds),callback:function ($$v) {_vm.channelCascadeIds=$$v},expression:"channelCascadeIds"}})
}
var staticRenderFns = []

export { render, staticRenderFns }